import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { publishLast, refCount } from 'rxjs/operators';
import { SettingsService } from '@app/core/settings/settings.service';
import { MemberService, PublicInfoResponse } from '@app/core/members/member.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberIdentifier } from '@app/core/_models/member-interface';
import { LoginV2CommonService } from '../../login-v2-common.service';
import { LoginService } from '@app/+login/login.service';
import { V2AuthAbstract } from '@app/+login/deprecated-hybrid/v2-auth.abstract.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputErrorsComponent } from '@app/shared/components/input-errors/input-errors.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { HYBRID_AUTH_PATH, HYBRID_REGISTER_PATH } from '@app/+login/consts';

const UNREGISTERED_IDENTIFIER_ERROR_KEY = 'unregistered_identifier';

@Component({
  selector: 'app-hybrid-login',
  templateUrl: './hybrid-login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    InputErrorsComponent,
    TranslatePipe,
    AsyncPipe,
    FormsModule,
  ],
})
export class HybridLoginComponent extends V2AuthAbstract implements OnInit {

  public settingsObservable = this.settingsService.getSettingsOnce().pipe(publishLast(), refCount());

  constructor(cdr: ChangeDetectorRef,
              memberService: MemberService,
              settingsService: SettingsService,
              route: ActivatedRoute,
              router: Router,
              private loginService: LoginService,
              private common: LoginV2CommonService) {
    super(cdr, route, router, memberService, settingsService);
  }

  public ngOnInit(): void {
    // redirect to member page if already logged in
    this.loginService.checkIfMemberBasicallyAuthenticated(this.route);
    super.ngOnInit();
  }

  public verifyPublicInfo(identifier: MemberIdentifier, publicInfo: PublicInfoResponse): void {
    if (publicInfo.exists) {
      this.common.navigateToAuthPage([HYBRID_AUTH_PATH], identifier, this.route, publicInfo);
    } else {
      this.formErrors = { error: UNREGISTERED_IDENTIFIER_ERROR_KEY };
      this.cdr.detectChanges();
    }
  }

  public navigateToRegisterPage(): void {
    this.router.navigate([HYBRID_REGISTER_PATH], {
      state: { identifierValue: this.formControl.value },
      relativeTo: this.route,
    });
  }
}
